/** Validates max string current input for gauges configuration (FR-004). */

export const MAX_CURRENT_INVALID_MESSAGE =
    'Informe um valor numérico maior que zero com no máximo uma casa decimal.';

export function parseMaxCurrentInput(raw: string): number | null {
    const trimmed = raw.trim().replace(',', '.');
    if (!trimmed) {
        return null;
    }
    const numeric = Number(trimmed);
    if (Number.isNaN(numeric)) {
        return null;
    }
    return numeric;
}

export function hasAtMostOneDecimal(value: number): boolean {
    const rounded = Math.round(value * 10) / 10;
    return Math.abs(value - rounded) < 1e-9;
}

export function isValidMaxCurrent(value: number | null | undefined): value is number {
    return (
        typeof value === 'number' &&
        Number.isFinite(value) &&
        value > 0 &&
        hasAtMostOneDecimal(value)
    );
}

export function validateMaxCurrentInput(raw: string): { ok: true; value: number } | { ok: false; message: string } {
    const parsed = parseMaxCurrentInput(raw);
    if (!isValidMaxCurrent(parsed)) {
        return { ok: false, message: MAX_CURRENT_INVALID_MESSAGE };
    }
    return { ok: true, value: parsed };
}
